// extracted by mini-css-extract-plugin
export default {"mainFilter":"MainFilter_mainFilter__x9wOZ","filter":"MainFilter_filter__DEmfP","filterLabel":"MainFilter_filterLabel__39ltU","filterInput":"MainFilter_filterInput__IE-rk"};